/**
 * 소식 게시판 — **관리는 Ghost에서 한다**(2026-09-21 사용자 지시).
 *
 * 종전 이 자리에는 자체 게시판 관리 화면(`AdminPostListPage`·`AdminPostEditPage`)이 있었다.
 * 09-15에 Ghost가 `haebom.it/news/`로 서고 발주기관이 거기에 직접 글을 올리기 시작하면서
 * **글 쓰는 자리가 둘**이 됐다 — 운영자가 어느 쪽에 써야 하는지 화면만 보고는 알 수 없었다.
 * 그래서 이 화면은 **관리 기능을 갖지 않고 Ghost로 보내는 일만** 한다.
 *
 * **서버의 게시판 API는 지우지 않았다** — 시민 화면(FE)의 `/board`가 아직 그것을 읽는다.
 * 그쪽 정리는 프론트엔드 담당(이현도) 판단이 선행이다
 * (요청 `docs/40_전달/2026-09-21-이현도-요청-소식메뉴-Ghost연결.md`).
 */

/**
 * Ghost 주소를 **현재 호스트에서 만든다** — 소스에 도메인을 박지 않기 위해서다(설계 원칙 13).
 * 관리자 화면은 `admin.haebom.it`이고 Ghost는 `haebom.it/news/`라 앞의 `admin.`만 뗀다.
 *
 * 개발(NKS)에는 Ghost가 없다. 호스트가 `admin.`으로 시작하지 않으면 **링크를 지어내지 않고**
 * `null`을 돌려주고, 화면이 "이 환경에는 없다"고 말한다 — 없는 주소를 눌러 404를 보는 것보다 낫다.
 */
function newsOrigin(): string | null {
  const { protocol, host } = window.location
  const prefix = 'admin.'
  if (!host.startsWith(prefix)) return null
  return `${protocol}//${host.slice(prefix.length)}`
}

export function AdminNewsGuidePage() {
  const origin = newsOrigin()

  return (
    <div>
      <div className="admin-bar">
        <div>
          <h1 className="page-title">소식 게시판</h1>
          <p className="page-desc">
            소식과 이야기는 <b>Ghost 게시판</b>에서 쓰고 고칩니다. 이 화면에서는 글을 쓰지 않습니다.
          </p>
        </div>
      </div>

      {origin === null ? (
        <section className="card-block">
          <h2>이 환경에는 소식 게시판이 없습니다</h2>
          <p className="muted small">
            소식 게시판은 운영(<code>haebom.it</code>)에만 설치돼 있습니다. 개발 환경에서는 열 수 없어
            주소를 함께 적지 않습니다.
          </p>
        </section>
      ) : (
        <>
          <section className="card-block">
            <h2>어디로 들어가나</h2>
            <p className="muted small">
              글을 쓰려면 <b>글 쓰는 곳</b>으로, 올라간 모습을 보려면 아래 목록으로 갑니다.
            </p>
            <div className="form-actions">
              <a className="btn" href={`${origin}/news/ghost/`} target="_blank" rel="noreferrer">
                글 쓰는 곳 (Ghost 관리자)
              </a>
              <a
                className="btn ghost"
                href={`${origin}/news/tag/notice/`}
                target="_blank"
                rel="noreferrer"
              >
                소식 목록
              </a>
              <a
                className="btn ghost"
                href={`${origin}/news/tag/story/`}
                target="_blank"
                rel="noreferrer"
              >
                이야기 목록
              </a>
            </div>
            {/* `/news/`(전체)를 링크로 두지 않는다 — 기본 테마가 컬렉션을 안 나눠 소식과 이야기가
                섞여 나온다. 운영자가 «소식 목록»으로 알고 열면 다른 것이 보인다. */}
            <p className="muted small">
              주소 <code>/news/</code>는 소식과 이야기가 <b>섞여</b> 나옵니다. 각각을 보려면 위
              두 버튼을 씁니다.
            </p>
          </section>

          <section className="card-block">
            <h2>글 쓰는 법</h2>
            <ol className="muted small">
              <li>새 글 → 제목·본문을 씁니다.</li>
              <li>
                오른쪽 설정에서 <b>태그를 하나</b> 고릅니다 — 소식이면 <code>notice</code>, 이야기면{' '}
                <code>story</code>.
              </li>
              <li>Publish를 누르면 시민 화면에 올라갑니다.</li>
            </ol>
            <p className="muted small">
              <b>태그를 고르지 않으면 어느 목록에도 뜨지 않습니다.</b> 담당자 성함·연락처는 본문에
              적지 않습니다.
            </p>
          </section>

          <section className="card-block">
            <h2>계정</h2>
            <p className="muted small">
              Ghost는 이 관리자 화면과 <b>계정이 따로</b>입니다. 로그인 정보가 필요하시면 담당자에게
              요청하세요 — 비밀번호는 화면·메신저에 적지 않고 별도 수단으로 전달합니다.
            </p>
          </section>
        </>
      )}
    </div>
  )
}
